import React, { useCallback } from 'react'
import { Field, FieldArray } from 'redux-form'

import DynamicInput from '../../../../Shared/Forms/DynamicInput'
import WrappedInput from '../../../../Shared/Forms/WrappedInput'
import Button from '../../../../Shared/Button'
import { IconButton } from '../../../../Shared/Icon'
import Row from './Row'
import EmptyState from '../../../../Shared/EmptyState'

import styles from './API.module.css'

const Item = function Item({ actionId, stepId, field, onRemove }) {
  return (
    <Row>
      <Field
        name={`${field}.name`}
        label="Name"
        component={WrappedInput}
        className={styles.key}
      />
      <Field
        name={`${field}.value`}
        label="Value"
        component={DynamicInput}
        actionId={actionId}
        stepId={stepId}
        className={styles.value}
      />
      <IconButton color="grey" icon="delete" onClick={onRemove} />
    </Row>
  )
}

const Fields = function Fields({
  fields,
  actionId,
  stepId,
  label,
  pluralLabel,
}) {
  const handleAdd = useCallback(() => {
    fields.push({})
  }, [fields])

  if (fields.length === 0) {
    return (
      <EmptyState tight>
        <h2>No {pluralLabel} Yet</h2>
        <Button color="grey" icon="add" type="button" onClick={handleAdd}>
          Add {label}
        </Button>
      </EmptyState>
    )
  }

  return (
    <div>
      {fields.map((field, index) => (
        <Item
          key={field}
          field={field}
          actionId={actionId}
          stepId={stepId}
          onRemove={() => fields.remove(index)}
        />
      ))}
      <Button small type="button" color="grey" icon="add" onClick={handleAdd}>
        Add Another {label}
      </Button>
    </div>
  )
}

export default function FieldsWrapper({
  actionId,
  stepId,
  label,
  pluralLabel,
  field,
}) {
  return (
    <FieldArray
      name={field}
      label={label}
      pluralLabel={pluralLabel}
      component={Fields}
      actionId={actionId}
      stepId={stepId}
    />
  )
}
